<ng-container *ngIf="isLoadingLessorRepresentative === false">

      <div class="contents">
        <div class="form_input">
          <h2 class="title">Representative</h2>

          <form [formGroup]="lessorRepresentativeForm">
            <div class="input">
              <label for="">Name</label>
              <input type="text"  (click)="onSearchDialog()" formControlName="Name"  class="default_input reference-form" />
            </div>

            <div class="input">
              <label for="">Phone</label>
              <input type="number" formControlName="PhoneNo" class="default_input reference-form" />
            </div>

            <div class="input">
              <label for="">Address</label>
              <input type="text" formControlName="Address" class="default_input reference-form" />
            </div>

            <div class="input">
              <label for="">Account Number</label>
              <input type="number" formControlName="AccountNo" class="default_input reference-form" />
            </div>

            <div class="input">
              <label for="">Representative Type</label>
              <select formControlName="LessorRepTypeId" class="default_input reference-form">
                <option *ngFor="let lessorRepType of lessorRepTypes"
                [value]="lessorRepType.id">{{ lessorRepType.LessorRepName }}</option>
              </select>
            </div>

            <div class="input">
              <label for="">Bank</label>
              <select formControlName="BankId" class="default_input reference-form">
                <option *ngFor="let bank of banks"
                [value]="bank.id">{{ bank.BankName }}</option>
              </select>
            </div>

            <div class="input">
              <label for="">From</label>
              <input type="date" formControlName="FromDate"  class="default_input reference-form" />
            </div>

            <div class="input">
              <label for="">To</label>
              <input type="date" formControlName="ToDate" class="default_input reference-form" />
            </div>
          </form>
          <div class="btn_holder">
            <button class="default_primary-button" (click)="addNew(lessorRepresentativeForm.getRawValue())" type="submit">
              <ng-container *ngIf="selectedIndex === null">
                Add  &rarr;
              </ng-container>
              <ng-container *ngIf="selectedIndex !== null">
                Update  &rarr;
              </ng-container>
            </button>

            <div class="refresh">
              <button mat-button (click)="onReset()">
                 <i class="material-icons">
                  settings_backup_restore
                  </i>Reset</button>
              </div>
          </div>
        </div>

  <cradua-lessor-representative-table
  [lessorRepresentatives]="lessorRepresentatives"
  [selectedLessorInfo]="selectedLessorInfo"
  [lessorRepTypes]="lessorRepTypes"
  [addressBook]="addressBook"
  [banks]="banks"
  (emitEdit)="onEdit($event)"
  >
  </cradua-lessor-representative-table>
</div>

<div class="acquisition_submit">
  <button class="default_primary-button" (click)="onSubmit()" type="submit">
    Save
  </button>
  <button class="default_secondary-btn ml-2" (click)="onBack()"> <i class="ti-arrow-left"></i> Back</button>

</div>
</ng-container>
<cradua-list-spinner
*ngIf="isLoadingLessorRepresentative === true"
>
</cradua-list-spinner>



